// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Placeholder__placeholder___ZRF72 {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}

.Placeholder__text___WmjFJ,
.Placeholder__icon___j9c_U {
    margin-bottom: 1.6rem;
}

.Placeholder__title___BYMW7 {
    margin-bottom: 0.8rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/Placeholder/Placeholder.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":[".placeholder {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n}\n\n.text,\n.icon {\n    margin-bottom: 1.6rem;\n}\n\n.title {\n    margin-bottom: 0.8rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"placeholder": `Placeholder__placeholder___ZRF72`,
	"text": `Placeholder__text___WmjFJ`,
	"icon": `Placeholder__icon___j9c_U`,
	"title": `Placeholder__title___BYMW7`
};
export default ___CSS_LOADER_EXPORT___;
